import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ListIcon from '@material-ui/icons/List';
import LockIcon from '@material-ui/icons/Lock';
import HistoryIcon from '@material-ui/icons/History';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

const defaultFilter = {
  idPartner: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function Users(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);
  const [selectedItemCheckedOptions, setSelectedItemCheckedOptions] = useState([]);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getUsers')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = e => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    setSelectedItemCheckedOptions([]);

    if (selectedItem === null || selectedItemOperation === null)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editUser':
        warning = warning === null ? selectedItem.name.length < 6 ? 'Numele utilizatorului este prea scurt' : null : warning;
        warning = warning === null ? selectedItem.username.length < 3 ? 'Numele de utilizator este prea scurt' : null : warning;
        warning = warning === null ? selectedItem.id === '' && selectedItem.newPassword.length < 6 ? 'Parola introdusa este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.newPassword !== selectedItem.confirmPassword ? 'Parolele introduse nu coincid' : null : warning;
        warning = warning === null ? selectedItem.idPartner === '0' && selectedItem.idBranch === '0' ? 'Nu ati selectat nici un punct de lucru' : null : warning;
        break;

      case 'changePassword':
        warning = warning === null ? selectedItem.newPassword.length < 6 ? 'Parola introdusa este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.newPassword !== selectedItem.confirmPassword ? 'Parolele introduse nu coincid' : null : warning;
        break;

      case 'userServices':
        setSelectedItemCheckedOptions(data.userServices.filter(userService => userService.idUser === selectedItem.id && userService.checked === '1').map(userService => userService.idService));
        break;

      case 'userPermissions':
        setSelectedItemCheckedOptions(data.userPermissions.filter(userPermission => userPermission.idUser === selectedItem.id && userPermission.checked === '1').map(userPermission => userPermission.idPermission));
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]);

  const handleItemCheckedOptionsToggle = value => () => {
    const currentIndex = selectedItemCheckedOptions.indexOf(value);
    const newChecked = [...selectedItemCheckedOptions];

    if (currentIndex === -1)
      newChecked.push(value);
    else
      newChecked.splice(currentIndex, 1);

    setSelectedItemCheckedOptions(newChecked);
  };

  const filterData = item => true
      && (filter.idPartner === '0' || item.idPartner === filter.idPartner)
      && (
           !!~item.name.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.username.toLowerCase().indexOf(filter.text.toLowerCase())
      )
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleEditUser = () => {
    setIsLoaded(false);
    ajax('saveUser', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleChangePassword = () => {
    setIsLoaded(false);
    ajax('saveUserPassword', {
      idUser: selectedItem.id,
      newPassword: selectedItem.newPassword,
      confirmPassword: selectedItem.confirmPassword
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          handleItemMenuClose();

        setIsLoaded(true);
      });
  };

  const handleSaveUserServices = () => {
    setIsLoaded(false);
    ajax('saveUserServices', {
      idUser: selectedItem.id,
      idServices: selectedItemCheckedOptions
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleSaveUserPermissions = () => {
    setIsLoaded(false);
    ajax('saveUserPermissions', {
      idUser: selectedItem.id,
      idPermissions: selectedItemCheckedOptions
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeleteUser = () => {
    setIsLoaded(false);
    ajax('markUserAsDeleted', {
      idUser: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeleteUser = () => {
    setIsLoaded(false);
    ajax('markUserAsUndeleted', {
      idUser: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Utilizatori</Typography>
      <Typography variant='subtitle2'>Administrare utilizatori interni si colaboratori.</Typography>
      <Typography variant='subtitle2'>Nu sunt afisati utilizatorii care sunt asociati unui partener care este inactiv sau sters.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.users.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.users.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select
              label='Partener'
              placeholder='Partener'
              name='idPartner'
              value={filter.idPartner}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toti partenerii</MenuItem>
              {data.partners.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.partner}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza utilizatorii stersi'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.users.length > 0 && data.users.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.users.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].partner !== a[i - 1].partner) &&
                <ListSubheader color='primary' disableSticky>{item.partner}</ListSubheader>
              }

              <ListItem dense button className={classes.listItemDense}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editUser');
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography style={{fontWeight: 'bold'}}>{item.name}</Typography>
                  }
                  secondary={
                    <Box>
                      <Typography component='span' display='inline' color='textSecondary'>
                        Nume de utilizator:
                        <Typography display='inline' color='textPrimary'>{` ${item.username}`}</Typography>
                      </Typography>
                      {filter.showExtendedInfo &&
                        <Box>
                          {item.idPartner === '0' &&
                            <Box>
                              <Typography color='textSecondary'>
                                {`Punct de lucru: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.branch}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`Casa de marcat: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.cashRegister}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`Imprimanta Zebra: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.zebraPrinter}</Typography>
                              </Typography>
                            </Box>
                          }
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editUser')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('changePassword')}>
          <ListItemIcon className={classes.listItemIcon}><VpnKeyIcon fontSize='small' color='action' /></ListItemIcon>
          <Typography variant='body1'>Schimba parola</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('userServices')}>
          <ListItemIcon className={classes.listItemIcon}><ListIcon fontSize='small' color='action' /></ListItemIcon>
          <Typography variant='body1'>Servicii asociate</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('userPermissions')}>
          <ListItemIcon className={classes.listItemIcon}><LockIcon fontSize='small' color='action' /></ListItemIcon>
          <Typography variant='body1'>Permisiuni aplicatie</Typography>
        </MenuItem>

        <MenuItem onClick={handleItemMenuClick('userLogs')}>
          <ListItemIcon className={classes.listItemIcon}><HistoryIcon fontSize='small' color='action' /></ListItemIcon>
          <Typography variant='body1'>Log (istoric)</Typography>
        </MenuItem>

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deleteUser')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeleteUser')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem({
              id: '',
              name: '',
              username: '',
              newPassword: '',
              confirmPassword: '',
              idPartner: '0',
              idBranch: '0',
              idCashRegister: '0',
              idZebraPrinter: '0',
              description: ''
            });
            setSelectedItemOperation('editUser');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga utilizator
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editUser' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editUser'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.name ? selectedItem.name : 'Adaugare utilizator nou'}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required select
                    label='Cont asociat partenerului'
                    placeholder='Cont asociat partenerului'
                    name='idPartner'
                    value={selectedItem.idPartner}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Nici un partener</MenuItem>
                    {data.partners.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.partner}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume si prenume'
                    placeholder='Nume si prenume'
                    name='name'
                    value={selectedItem.name}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume de utilizator'
                    placeholder='Nume de utilizator'
                    name='username'
                    value={selectedItem.username}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {!Boolean(selectedItem.id) &&
                    <TextField margin='none' required autoComplete='new-password' type='password'
                      label='Parola noua'
                      placeholder='Parola noua'
                      name='newPassword'
                      value={selectedItem.newPassword}
                      onChange={handleSelectedItemChange}
                    />
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {!Boolean(selectedItem.id) &&
                    <TextField margin='none' required autoComplete='new-password' type='password'
                      label='Confirmare parola'
                      placeholder='Confirmare parola'
                      name='confirmPassword'
                      value={selectedItem.confirmPassword}
                      onChange={handleSelectedItemChange}
                    />
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required select
                    disabled={Boolean(parseInt(selectedItem.idPartner))}
                    label='Punct de lucru'
                    placeholder='Punct de lucru'
                    name='idBranch'
                    value={selectedItem.idBranch}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Nici un punct de lucru</MenuItem>
                    {data.branches.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.branch}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required select
                    disabled={Boolean(parseInt(selectedItem.idPartner))}
                    label='Casa de marcat'
                    placeholder='Casa de marcat'
                    name='idCashRegister'
                    value={selectedItem.idCashRegister}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Nici o casa de marcat</MenuItem>
                    {data.cashRegisters.filter(item => item.idBranch === selectedItem.idBranch).map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.cashRegister}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required select
                    disabled={Boolean(parseInt(selectedItem.idPartner))}
                    label='Imprimanta Zebra'
                    placeholder='Imprimanta Zebra'
                    name='idZebraPrinter'
                    value={selectedItem.idZebraPrinter}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Nici o imprimanta</MenuItem>
                    {data.zebraPrinters.filter(item => item.idBranch === selectedItem.idBranch).map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.zebraPrinter}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={selectedItem.description}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditUser}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'changePassword' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'changePassword'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.name}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='new-password' type='password'
                    label='Parola noua'
                    placeholder='Parola noua'
                    name='newPassword'
                    value={selectedItem.newPassword}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='new-password' type='password'
                    label='Confirmare parola'
                    placeholder='Confirmare parola'
                    name='confirmPassword'
                    value={selectedItem.confirmPassword}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleChangePassword}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'userServices' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'userServices'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Servicii asociate - {selectedItem.name}</DialogTitle>
          <DialogContent>
            <List dense>
              {data.services.map((item, i, a) =>
                <Fragment key={item.id}>
                  {(i === 0 || a[i].serviceCategory !== a[i - 1].serviceCategory) &&
                    <ListSubheader color='primary' disableSticky>{item.serviceCategory}</ListSubheader>
                  }

                  <ListItem dense button className={classes.listItemDense}
                    onClick={handleItemCheckedOptionsToggle(item.id)}
                  >
                    <ListItemIcon>
                      <Checkbox size='small' disableRipple edge='start' tabIndex={-1} color='primary'
                        checked={selectedItemCheckedOptions.indexOf(item.id) !== -1}
                      />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemTextDense} disableTypography
                      primary={item.service}
                      secondary={
                        <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                      }
                    />
                  </ListItem>
                </Fragment>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            <FormControlLabel style={{marginLeft: '32px', marginRight: 'auto'}}
              control={
                <Checkbox size='small' disableRipple edge='start' color='secondary'
                  checked={selectedItemCheckedOptions.length > 0} // using selectedItemCheckedOptions.length === data.services.length will make a grey checkbox for indeterminate value
                  indeterminate={selectedItemCheckedOptions.length > 0 && selectedItemCheckedOptions.length !== data.services.length}
                  onChange={() => {
                    setSelectedItemCheckedOptions(selectedItemCheckedOptions.length === data.services.length ? [] : data.services.map(service => service.id));
                  }}
                />
              }
              label={
                <Typography color='secondary'>{selectedItemCheckedOptions.length === data.services.length ? 'Deselecteaza tot' : 'Selecteaza tot'}</Typography>
              }
            />
          </DialogActions>
          <DialogActions>
            <Link to='/ResellerServices' className={classes.link} style={{marginRight: 'auto'}}>
              <Button style={{color: 'darkblue'}}>
                Servicii
              </Button>
            </Link>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSaveUserServices}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'userPermissions' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'userPermissions'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Drepturi aplicatie - {selectedItem.name}</DialogTitle>
          <DialogContent>
            <List dense>
              {data.permissions.map((item, i, a) =>
                <Fragment key={item.id}>
                  {(i === 0 || a[i].permissionCategory !== a[i - 1].permissionCategory) &&
                    <ListSubheader color='primary' disableSticky>{item.permissionCategory}</ListSubheader>
                  }

                  <ListItem dense button className={classes.listItemDense}
                    onClick={handleItemCheckedOptionsToggle(item.id)}
                  >
                    <ListItemIcon>
                      <Checkbox size='small' disableRipple edge='start' tabIndex={-1} color='primary'
                        checked={selectedItemCheckedOptions.indexOf(item.id) !== -1}
                      />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemTextDense}
                      primary={item.permission}
                      secondary={
                        <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                      }
                    />
                  </ListItem>
                </Fragment>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            <FormControlLabel style={{marginLeft: '32px', marginRight: 'auto'}}
              control={
                <Checkbox size='small' disableRipple edge='start' color='secondary'
                  checked={selectedItemCheckedOptions.length > 0} // using selectedItemCheckedOptions.length === data.permissions.length will make a grey checkbox for indeterminate value
                  indeterminate={selectedItemCheckedOptions.length > 0 && selectedItemCheckedOptions.length !== data.permissions.length}
                  onChange={() => {
                    setSelectedItemCheckedOptions(selectedItemCheckedOptions.length === data.permissions.length ? [] : data.permissions.map(permission => permission.id));
                  }}
                />
              }
              label={
                <Typography color='secondary'>{selectedItemCheckedOptions.length === data.permissions.length ? 'Deselecteaza tot' : 'Selecteaza tot'}</Typography>
              }
            />
          </DialogActions>
          <DialogActions>
            <Link to='/Permissions' className={classes.link} style={{marginRight: 'auto'}}>
            <Button style={{color: 'darkblue'}}>
                Permisiuni
              </Button>
            </Link>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSaveUserPermissions}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'userLogs' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted maxWidth='md'
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'userLogs'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Loguri - {selectedItem.name}</DialogTitle>
          <DialogContent>
            <List dense>
              {data.userLogs.filter(item => item.actionBy === selectedItem.id).map((item, i, a) =>
                <Fragment key={i}>
                  {(i === 0 || a[i].actionDate !== a[i - 1].actionDate) &&
                    <ListSubheader color='primary' disableSticky>{item.actionDate}</ListSubheader>
                  }

                  <ListItem dense className={classes.listItemDense}>
                    <ListItemText className={classes.listItemTextDense} disableTypography
                      primary={
                        <Typography component='span' color='textSecondary'>
                          {`${item.actionTime} - `}
                          <Typography color={item.isDelete === '1' ? 'secondary' : 'textPrimary'} display='inline'>{item.action}</Typography>
                        </Typography>
                      }
                    />
                  </ListItem>
                </Fragment>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Inchide
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deleteUser' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deleteUser'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati acest utilizator ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti acest utilizator. Dupa stergere, acest utilizator nu va mai avea acces in aplicatie.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeleteUser}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeleteUser' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeleteUser'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestui utilizator ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestui utilizator. Dupa confirmare, acest utilizator va avea din nou acces in aplicatie.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeleteUser}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}